import api from './api';

// Tipos (deben coincidir con el backend)
export interface ThermometerCell {
  row: number;
  col: number;
  n: number;
}

export interface Thermometer {
  index: number;
  type: number;
  cells: ThermometerCell[];
}

export interface ParsedTask {
  width: number;
  height: number;
  verticalCounters: number[];
  horizontalCounters: number[];
  thermometers: Thermometer[];
  grid?: number[][];
}

export interface ThermometerBoard {
  id: number;
  task: string;
  size: number;
  parsed: ParsedTask;
}

export interface ValidationError {
  type: 'counter' | 'thermometer';
  direction?: 'vertical' | 'horizontal';
  index?: number;
  thermIndex?: number;
}

export interface ValidationResult {
  valid: boolean;
  errors: ValidationError[];
}

/**
 * Obtener tablero de termómetros
 */
export async function getThermometerBoard(dificultad?: number, tableroId?: number): Promise<ThermometerBoard> {
  const params = new URLSearchParams();
  
  if (tableroId) {
    params.append('tableroId', tableroId.toString());
  } else if (dificultad) {
    params.append('dificultad', dificultad.toString());
  }

  const response = await api.get(`/thermometers/board?${params.toString()}`);
  return response.data;
}

/**
 * Obtener solución completa
 */
export async function getThermometerSolution(task: string): Promise<number[][]> {
  const response = await api.post('/thermometers/solution', { task });
  return response.data.solution;
}

/**
 * Obtener pista
 */
export async function getThermometerHint(
  task: string,
  state: { [row: number]: { [col: number]: number } }
): Promise<{ row: number | null; col: number | null; value: number | null }> {
  const response = await api.post('/thermometers/hint', { task, state });
  return response.data;
}

/**
 * Validar solución de termómetros
 */
export async function validateThermometerSolution(
  task: string,
  state: { [row: number]: { [col: number]: number } }
): Promise<ValidationResult> {
  const response = await api.post('/thermometers/validate', {
    task,
    state
  });
  return response.data;
}
